import { ReactComponent as Animation } from '../../assets/loading-animation.svg';

export default function Loading() {
  return (
    <div className='loader'>
      <Animation />
    </div>
  );
}
